import { CourseData } from '../../../data-grid-container/courses/types/courses.types';
import { RouteHelpersModalConstants } from '@containers/activity-router/routes/helpers/modal/route-modal-helpers.types';
import { DefaultState } from '@containers/activity-router/routes/helpers/slice/slice.types';
import {
    GridCells,
    GridCounters
} from '@containers/activity-router/routes/helpers/slice/topic/topic-slice.types';
import {
    TransformedSkillsQuestAssignments
} from '@services/gateways/combined-assign-gateway/combined-assign-gateway.types';
import { UpfAssignCurriculumList } from '@services/gateways/upf-assign-gateway/upf-assign-gateway.types';

export enum SkillQuestsConstants {
    name = 'skillQuests'
}

export type SkillQuestsState = DefaultState & {
    course: {
        selected: CourseData
    }
    grid: {
        cells: GridCells
        counters: GridCounters
    }
    assignments: {
        grid: TransformedSkillsQuestAssignments
    }
    modal: RouteHelpersModalConstants | null
    filters: {
        isExpanded: boolean
        courseId: string | null
        curriculumCourse: UpfAssignCurriculumList
    }
};
